<template>
  <div class="laboratory px">
    <c-password @select="onClick" />
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      :image="images['device_' + currentDevice.code]"
      @close="$router.replace($paths.firmware)"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      percent: -1,
      progressText: "",
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
  },
  methods: {
    onClick() {
      this.$store.dispatch("loader/loadFirmware");
    },
  },
  mounted() {
    window.updatingFirmwareProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getSystemInfo");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.laboratory {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .button {
    @include linear-button;
    width: 480px;
    height: 80px;
    line-height: 80px;
    margin-bottom: 60px;
  }

  .password-text {
    font-size: 36px;
    margin-bottom: 20px;
  }

  .password-input {
    width: 100px;
    height: 80px;
    border: none;
    outline: none;
    text-align: center;
    border-bottom: 2px solid #ebebeb;
    margin-right: 20px;
    font-weight: 500;
    font-size: 48px;
    caret-color: $primary-color;

    &:focus {
      border-color: $primary-color;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .password-error {
    height: 50px;
    font-size: 32px;
    color: #e43e3b;
    margin-top: 20px;
    margin-bottom: 180px;
  }
}
</style>
